import React from 'react';
import { Loader, useForm, FormCouponGift } from '/src/components';
import {
    useCartContext,
    useModalsContext,
    useStoreConfigContext
} from '/src/providers';

const Gift = () => {
    const { translate } = useStoreConfigContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const {
        cart: { id: cartId },
        isLoadingCart,
        applyGiftCardToCart,
    } = useCartContext();
    const { data, handleChange } = useForm({ gift: '' });

    const handleSubmit = e => {
        e.preventDefault();

        applyGiftCardToCart({
            input: {
                cart_id: cartId,
                gift_card_code: data.gift,
            }
        }).then(() => {
            handleChange({ target: { name: 'gift', value: '', type: 'text' } });
        }).catch(errors => showModal(MODALS_TYPES.ERROR, { errors }))
    };

    return (
        <Loader isLoading={isLoadingCart}>
            <FormCouponGift
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                name="gift"
                data={data.gift}
                isLoading={isLoadingCart}
                translate={translate}
            />
        </Loader>
    )
};

export default Gift;
